import { CampaignTypeFilter } from "@dev/ee-api/ee-api-models";

export const defaultParams = {
    limit: 3,
    offset: 0,
    isUrlUpdateDisabled: true,
    type: [CampaignTypeFilter.SendNow, CampaignTypeFilter.AbSplit],
};

export const columnsWidth = {
    preview: '84px',
    opened: '70px',
    clicked: '70px',
    status: '110px',
    dropdown: '20px',
};
